import * as Reflux from "reflux";
export const SavedCartActions = {
	setItemQuantity: Reflux.createAction(["setItemQuantity"]),
	deleteItem: Reflux.createAction(["deleteItem"]),
	deleteItems: Reflux.createAction(["deleteItems"]),
	deleteCart: Reflux.createAction(["deleteCart"]),
	deleteSpecificCart: Reflux.createAction(["deleteSpecificCart"]),
	addSavedCartOptimistically: Reflux.createAction(["addSavedCartOptimistically"]),
};
